import { doc, setDoc } from 'firebase/firestore';

/**
 * Add Song Wizard is optional onboarding; once completed it must not reappear.
 * Uses localStorage + profiles.add_song_wizard_completed in Firestore.
 */
export const ADD_SONG_WIZARD_DONE_KEY = 'ysr_songs_added_first_time';
export const SHOW_WIZARD_TRIGGER_KEY = 'ysr_show_song_wizard';
/** User closed the wizard without finishing; don't auto-reopen until they revisit catalogue (flag cleared). */
export const ADD_SONG_WIZARD_DISMISSED_KEY = 'ysr_add_songs_wizard_dismissed';
/** Encouraged first catalogue size before we stop nudging with the wizard. */
export const ADD_SONG_WIZARD_TARGET_COUNT = 5;

export function markAddSongWizardCompletedLocal() {
  try {
    localStorage.setItem(ADD_SONG_WIZARD_DONE_KEY, 'true');
    localStorage.removeItem(SHOW_WIZARD_TRIGGER_KEY);
    localStorage.removeItem(ADD_SONG_WIZARD_DISMISSED_KEY);
  } catch (_) {
    /* ignore */
  }
}

export function hasCompletedAddSongWizardLocal() {
  try {
    return localStorage.getItem(ADD_SONG_WIZARD_DONE_KEY) === 'true';
  } catch (_) {
    return false;
  }
}

/** True if onboarding wizard should not auto-open (user finished, dismissed, or reached encouraged catalogue size). */
export function isAddSongWizardCompleted(profile, songCount) {
  if (hasCompletedAddSongWizardLocal()) return true;
  if (profile?.add_song_wizard_completed === true) return true;
  if (typeof songCount === 'number' && songCount >= ADD_SONG_WIZARD_TARGET_COUNT) return true;
  return false;
}

/** Persist completion (local + Firestore profile) so it survives devices/browsers. */
export async function persistAddSongWizardCompleted(db, userId) {
  markAddSongWizardCompletedLocal();
  if (!db || !userId) return;
  try {
    await setDoc(
      doc(db, 'profiles', userId),
      { add_song_wizard_completed: true },
      { merge: true }
    );
  } catch (e) {
    console.warn('persistAddSongWizardCompleted:', e);
  }
}

/** Artists who already built an encouraged-sized catalogue sync wizard-done (e.g. new browser). */
export async function ensureWizardDoneIfHasSongs(db, userId, songCount) {
  if (!userId || !songCount || songCount < ADD_SONG_WIZARD_TARGET_COUNT) return;
  if (hasCompletedAddSongWizardLocal()) return;
  await persistAddSongWizardCompleted(db, userId);
}
